// vue
import Vue from 'vue';

// app.vue
import App from './App';

// router
import router from './router';

// component for code display
import DemoBlock from './components/DemoBlock.vue';
Vue.component('demo-block', DemoBlock);

// plugin
import "../src/npm.js";

// productionTip
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./examples/main.js